import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  minWidth: {
    xs: '100%',
    sm: '25.4rem',
    md: '30.9rem',
    lg: '37.6rem',
    xl: '53.6rem',
  },
  maxWidth: {
    xs: '25.4rem',
    md: '30.9rem',
    lg: '37.6rem',
    xl: '53.6rem',
  },
  padding: {
    xs: '1.6rem',
    md: '2.4rem',
  },
  textAlign: 'start',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  minHeight: {
    xs: '39.1rem',
    md: '39.7rem',
    lg: '41.4rem',
  },
  borderRadius: '0.8rem',
}

export const contentSx: SxProps<Theme> = {
  flex: 1,
  padding: {
    xs: '0.6rem 0 0 0 !important',
    md: '1.2rem 0 0 0 !important',
    lg: '1.8rem 0 0 0 !important',
  },
  gap: {
    xs: '0.6rem',
    md: '1.2rem',
    lg: '1.8rem',
  },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  width: '100%',
  maxWidth: '100%',
}

export const titleSx: SxProps<Theme> = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: '100%',
}

export const imageSx: SxProps<Theme> = {
  width: '100%',
  height: '18.8rem',
  objectFit: 'cover',
}

export const readArticleButtonSx: SxProps<Theme> = {
  marginTop: 'auto',
  marginLeft: '-1.2rem',
}
